/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.modals.published.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions'
])

.controller('TemplatesModalsPublishedController', [
  '$scope',
  '$state',
  '$sce',
  '$uibModalInstance',
  'ApiService',
  'PermissionsService',
  'template',
   function($scope,
            $state,
            $sce,
            $uibModalInstance,
            ApiService,
            PermissionsService,
            template) {

  $scope.templatesModalsPublished = {

    model: {
      displayOrder: template.displayOrder,
      totalItems: 0
    },
    errors: [],
    template: template,
    title: 'Your Publish is Underway',
    message: '',
    subMessage: '',
    isSaving: false,
    isLoading: false,
    goToOrderedListOnSave: false,

    init: function () {
      this.message = '"' + this.template.name + '" is being published and may take a few minutes to appear.';
      this.subMessage = 'You can continue working in Backoffice in the meantime.';
      this.getDisplayOrder();
    },

    getDisplayOrder: function() {
      this.isLoading = true;
      ApiService.program.displayOrderCount({ eventTemplateId: this.template.id }).then(this.success.displayOrderCount, this.error.displayOrderCount);
    },

    launchOrderedList: function() {
      this.goToOrderedListOnSave = true;
      this.save();
    },

    save: function() {
      this.errors = [];
      this.isSaving = true;
      if (this.allowSave && PermissionsService.check('EVENT_TEMPLATE_REORDER')) {
        ApiService.program.reorder([{
          displayOrder: this.model.displayOrder,
          id: this.template.id,
          name: this.template.name,
          description: this.template.description
        }]).then(this.success.save, this.error.save);
      }else{
        this.done();
      }
    },

    done: function () {
      $uibModalInstance.close(this.goToOrderedListOnSave);
      if (this.goToOrderedListOnSave) {
        $state.go('application.templates.reorder');
      }
    },

    cancel: function () {
      $uibModalInstance.dismiss();
    },

    success: {
      init: function (response) {},
      displayOrderCount: function(response) {
        var self = $scope.templatesModalsPublished;
        self.model.displayOrder = response.data.payload.displayOrder.displayOrder;
        self.model.totalItems = response.data.payload.count;
        self.isLoading = false;
        self.allowSave = true;
      },
      save: function(response) {
        var self = $scope.templatesModalsPublished;

        self.done();
        self.isSaving = false;
      }
    },

    error: {
      init: function (response) {},
      displayOrderCount: function(response) {
        var self = $scope.templatesModalsPublished;
        self.errors = [response.data.error];
        self.isLoading = false;
        self.allowSave = false;
      },
      save: function(response) {
        var self = $scope.templatesModalsPublished;

        self.errors = [response.data.error];
        self.isSaving = false;
      }
    }
  };

  $scope.templatesModalsPublished.init();

}]);
